import constants from '../constants';
import Contact from '../Model/models/contactModel';
import Location from '../Model/models/locationModel';
import Order from '../Model/models/orderModel';
import OrderProduct from '../Model/models/orderProductModel';
import Shipping from '../Model/models/shippingModel';
import OrderPayment from '../Model/Payment';
import authAxios from '../authorization/axios';

export class OrdersService {

  create(
    order: Order,
    orderProducts: OrderProduct[],
    newBilling?: Location,
    newContact?: Contact,
    shippings: Shipping[] = [],
    payments: OrderPayment[] = []
  ) {
    return authAxios.post(`${constants.api.base}/orders`, {
      order,
      orderProducts,
      newBilling,
      newContact,
      shippings,
      payments
    }).then(res => {
      return res.data;
    });
  }

  update(
    order: Order,
    orderProducts: OrderProduct[],
    newBilling?: Location,
    newContact?: Contact,
    shippings: Shipping[] = []
  ) {
    return authAxios.put(`${constants.api.base}/orders`, {
      order,
      orderProducts,
      newBilling,
      newContact,
      shippings
    }).then(res => {
      return res.data;
    });
  }

}

